<template>
    <!-- <div class="row featurette">
        <div class="col-md-7 order-md-2">
            <h2 class="featurette-heading fw-normal lh-1">
                Oh yeah, it’s that good.
                <span class="text-muted">{{data.name}}</span>
            </h2>
            <p class="lead">
                {{data.about}}
            </p>
        </div>
        <div class="col-md-5 order-md-1">
            <img :src="data.image" style="width: 600px;">
        </div>
    </div>-->

    <div class="card bg-transparent mb-3 text-light fs-4">
        <div class="row">
            <div class="col">
                <img :src="data.image" class="img-fluid rounded-start" :alt="data.name" />
            </div>
            <div class="col-md-8">
                <div class="card-body">
                    <h5 class="card-title fs-1 mb-4">{{data.name}}</h5>
                    <p class="card-text" v-html="data.about"></p>
                    <!-- <p class="card-text">
                        <small class="text-muted">{{data.email}}</small>
                    </p> -->
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: "ProfileC",
        props: ["data"],
        setup() {
            return {};
        },
    };
</script>